import { Ability } from './Ability'

const roles = {
  manager: {
    rules: [
      {
        actions: ['read', 'update'],
        subject: ['User'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['Approve'],
      },
      {
        actions: ['read'],
        subject: ['faq'],
      },
    ],
  },
  learning_manager: {
    rules: [
      {
        actions: ['read', 'update'],
        subject: ['User'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['Approve'],
      },
      {
        actions: ['read'],
        subject: ['faq'],
      },
    ],
  },
  event_manager: {
    rules: [
      {
        actions: ['read'],
        subject: ['Events'],
      },
      {
        actions: ['read'],
        subject: ['faq'],
      },
    ],
  },
  event_instructor: {
    rules: [
      {
        actions: ['read'],
        subject: ['Events'],
      },
      {
        actions: ['read'],
        subject: ['faq'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['Approve'],
      },
    ],
  },
  local_superuser: {
    rules: [
      {
        actions: ['read', 'update', 'create'],
        subject: ['User'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['Approve'],
      },
      {
        actions: ['read', 'update', 'create'],
        subject: ['Product'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['ProductCategories'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['Groups'],
      },
      {
        actions: ['read'],
        subject: ['faq'],
      },
      {
        actions: ['read'],
        subject: ['Policies'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['News'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['Certificates'],
      },
    ],
  },
  superuser: {
    rules: [
      {
        actions: ['read', 'update', 'create'],
        subject: ['User'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['Approve'],
      },
      {
        actions: ['read', 'update', 'create'],
        subject: ['Product'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['Events'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['ProductCategories'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['Groups'],
      },
      {
        actions: ['read'],
        subject: ['faq'],
      },
      {
        actions: ['read'],
        subject: ['Policies'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['News'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['Certificates'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['Company'],
      },
      {
        actions: ['read', 'update'],
        subject: ['CompanySettings'],
      },
    ],
  },
  admin: {
    rules: [
      {
        actions: ['read', 'update', 'create'],
        subject: ['User'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['Approve'],
      },
      {
        actions: ['read', 'update', 'create'],
        subject: ['Product'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['ProductCategories'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['Groups'],
      },
      {
        actions: ['read'],
        subject: ['faq'],
      },
      {
        actions: ['read'],
        subject: ['Policies'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['News'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['Certificates'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['Company'],
      },
      {
        actions: ['read', 'update'],
        subject: ['CompanySettings'],
      },
    ],
  },
  superadmin: {
    rules: [
      {
        actions: ['read', 'update', 'create'],
        subject: ['all'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['ProductCategories'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['Groups'],
      },
      {
        actions: ['read', 'update', 'create', 'delete'],
        subject: ['Company'],
      },
    ],
  },
  supervisor: {
    rules: [
      {
        actions: ['read', 'update', 'create'],
        subject: ['enable_reports_dashboard'],
      },
    ],
  },
}

export const defineAbilitiesForRoleAndRules = (userRoles, rules = []) => {
  const userRules = userRoles.flatMap((role) => roles[role]?.rules ?? [])
  return new Ability([...userRules, ...rules])
}
